module.exports = __webpack_public_path__ + "static/media/20ECE4.1ff5a252.jpg";